import { render, staticRenderFns } from "./Earth.vue?vue&type=template&id=076f6c18&scoped=true&"
import script from "./Earth.vue?vue&type=script&lang=js&"
export * from "./Earth.vue?vue&type=script&lang=js&"
import style0 from "./Earth.vue?vue&type=style&index=0&id=076f6c18&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076f6c18",
  null
  
)

export default component.exports